<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="row">
            <div class="col-sm-6">
              <div class="media">
                <div class="avatar-sm mr-3">
                  <span
                    class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
                  >
                    <i class="bx bx-news bx-md"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h5 class="mt-3">
                    {{ $t("news.news-target-detail") }}
                    <a
                      :href="'/project-overview/' + target.id_target"
                      target="_blank"
                      v-if="target.id_target"
                    >
                      ( <span class="text-primary">{{ target.title }}</span
                      >)</a
                    >
                  </h5>
                </div>
              </div>
            </div>
            <div class="col-sm-6 text-right">
              <h5 class="mt-3 mr-4" v-if="tableData">
                {{ tableData.length }} {{ $t("news.total-results") }}
              </h5>
            </div>
          </div>
          <div class="col-12">
            <hr />
            <div v-if="!loading && !tableData[0]" class="mt-4 mx-auto p-5">
              <div class="text-center">
                {{ $t("overview.table.all.dnf") }}
              </div>
            </div>
          </div>
          <div v-if="loading" class="mt-4 mx-auto p-5">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              ></div>
            </div>
          </div>
          <div class="col-sm-12" v-if="!loading && tableData[0]">
            <div class="row mt-4 mb-2">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t("news.show") }}&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="md"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select>
                    </label>
                  </div>
                  <b-button
                    size="md"
                    variant="danger"
                    class="btn"
                    @click="bulkAction"
                    style="height: 3%"
                    :disabled="selected.length == 0"
                  >
                    <!-- <i class="fas fa-trash mr-0 py-2"></i> -->
                    {{ $t("button.hapus.text") }} {{ selected.length }} Data
                  </b-button>
                  <!-- <b-button  size="sm" variant="danger" class="btn ml-1" style="height: 3%" >
                                        <i class="fas fa-times py-2 m-0"></i>
                                        Delete All
                                    </b-button> -->
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("news.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('news.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk)>
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(bulk)="row">
                  <b-form-checkbox
                    class="text-center mt-0"
                    v-model="selected"
                    :value="row.item.id_news"
                  />
                </template>
                <template #cell(published)="row">
                  <div>
                    <div class="media">
                      <div class="media-body">
                        <b> {{ row.item.source }}</b> <br />
                        <small>
                          <!-- <p class="text-secondary">Author : {{row.item.author}} </p>  -->
                          <p class="text-secondary">
                            <span>
                              {{ $t("news.author") }} : {{ row.item.author }}
                            </span>
                            <br />
                            <span>
                              {{ $t("news.published_at") }} :
                              {{ row.item.published_at }}
                            </span>
                          </p>
                        </small>
                      </div>
                    </div>
                  </div>
                </template>
                <template #cell(image)="row">
                  <div>
                    <img
                      :src="row.item.image"
                      class="img-fluid"
                      width="100%"
                      alt="news-pict"
                    />
                  </div>
                </template>
                <template #cell(title)="row">
                  <div>
                    <a
                      :href="row.item.url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>{{ row.item.title }}</span></a
                    >
                  </div>
                </template>
                <template #cell(content)="row">
                  <div>
                    <span>{{ row.item.content.substring(0, 200) }}..</span>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div class="col-md-12 text-center">
                    <button
                      target="_blank"
                      class="btn btn-danger btn-sm text-white"
                      @click="deleteNews(row.item.id_news)"
                    >
                      <i class="bx bx-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>

              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="tableData.length > 9">
              <div class="col-sm-12 text-right">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 text-center"
            v-if="!tableData[0] && !loading && search"
          >
            <p class="text-secondary p-5">{{ $t("overview.table.all.dnf") }}</p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import NewsService from "@/helpers/news.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      backUrl: "/news/news-target",
      url_image:
        process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      id: this.$route.params.id,
      target: "",
      loading: false,
      loadingInfo: false,
      loadingsubdomain: false,
      search: false,
      searchKey: "",
      SearchResult: "",
      total_results: "",
      relation: [],
      options: [],
      tableData: [],
      searchTarget: "",
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,

      selected: [],
      selectAll: false,

      title: this.$t("news.news-target-detail"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("news.news"),
          href: "/news",
        },
        {
          text: this.$t("news.news-target"),
          href: "/news/news-target",
        },
        {
          text: this.$t("news.news-target-detail"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "bulk", thStyle: { width: "2%" } },
        {
          key: "published",
          thStyle: { width: "10%" },
          label: this.$t("news.published_at"),
        },
        {
          key: "image",
          class: "text-center",
          thStyle: { width: "15%" },
          label: this.$t("news.image"),
        },
        {
          key: "title",
          thStyle: { width: "30%" },
          label: this.$t("news.title"),
        },
        {
          key: "content",
          thStyle: { width: "40%" },
          label: this.$t("news.content"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("news.actions"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },
  },
  methods: {
    select() {
      // console.log('selected');
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_news);
        }
      }
    },

    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },

    getNews() {
      this.loading = true;
      this.tableData = [];
      NewsService.getNewsByID(this.id)
        .then((response) => {
          // console.log(response.data.data);
          response.data.data.forEach((val) => {
            let data = {
              id_news: val.id_news,
              author: val.author,
              content: val.content,
              image: val.image,
              published_at: val.published_at,
              source: val.source,
              title: val.title,
              url: val.url,
            };
            this.tableData.push(data);
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log("d target -> ", err);
          this.loading = false;
        });
    },

    async getTargetDetail() {
      await TargetService.getDetailTarget(this.id)
        .then((response) => {
          this.target = response.data.data;
        })
        .catch((err) => {
          console.log("d target -> ", err);
        });
    },

    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          // console.log(data);
          NewsService.newsBulkDelete(data)
            .then((response) => {
              this.selected = [];
              this.getNews();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteNews(id_news) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(id_news);
          NewsService.newsDelete(id_news)
            .then((response) => {
              this.selected = [];
              this.getNews();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    onOptionClick(option) {
      this.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },

  beforeMount() {
    this.getTargetDetail();
  },
  mounted() {
    this.getNews();
    this.totalRows = this.items.length;
    // this.getNewsInfo();
    this.availableOptions;
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
